/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { ExtComponent } from '../../components/Ext/ExtComponent';

export const SecurityApiKeysPage: React.FC<{}> = () => {
    const xtype = 'configuration.security.keys.grid';

    return (
        <TabBarBodyLayout>
            <ExtComponent
                xtype={xtype}
            />
        </TabBarBodyLayout>
    );
};
